interface CleartaxUrlConfiguration {
  assessmentYear: string;
  entityIndex: string;
}

export const defaultClearTaxConfiguration = {
  assessmentYear: '2019',
  entityIndex: '0',
};

export const parsePaytaxUriOrGiveDefault = (
  location: string
): CleartaxUrlConfiguration => {
  const regex = /.*\/y(\d{4})\/(\d+).*/g;
  const matches = regex.exec(location);
  if (!matches) {
    return defaultClearTaxConfiguration;
  }
  return {
    assessmentYear: matches[1],
    entityIndex: matches[2],
  };
};

export const getCurrentCleartaxConfig = (): CleartaxUrlConfiguration => {
  if (
    typeof window !== 'undefined' &&
    window &&
    window.parent &&
    window.parent.location &&
    window.parent.location.href
  ) {
    return parsePaytaxUriOrGiveDefault(window.parent.location.href);
  } else {
    return defaultClearTaxConfiguration;
  }
};



// WEBPACK FOOTER //
// ./utils/location.ts